<template>
  <ContentPage back>
    <template #header>
      <content-page-title>
        Failed Payment
      </content-page-title>
    </template>

    <Section class="d-flex flex-column" style="font-size: 16px;">
      <div class="d-flex">
        <div>Payment Date</div>
        <div class="ml-auto">{{ formatDate(payment.payment_date) }}</div>
      </div>
      
      <div class="d-flex mt-4">
        No changes were made to your account.
      </div>
    </Section>
  </ContentPage>
</template>

<script>

import formatters from '@/lib/formatters'
import { ContentPage, ContentPageTitle, Section } from '@/components/pages'

export default {
  name: 'FailedPayment',

  props: {
    payment: {
      type: Object,
      required: true,
    },
  },

  components: { ContentPage, ContentPageTitle, Section },

  methods: {
    ...formatters,
  },
}
</script>